import React, { useState } from 'react';
import { RiDeleteBin6Line } from 'react-icons/ri';
import HSModal from '../../../../../common/Modal';
import HSButton from '../../../../../common/Button';
import Apis from '../../../../../../api';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/rootReducer';
import MessageActions from '../../../../../message/redux/actions';
import LoginActions from '../../../../../login/redux/actions';

type Props = {
    uuid: string;
};

const DeleteAIDoc: React.FC<Props> = ({ uuid }) => {
    const dispatch = useDispatch();

    const investorUUID = useSelector((state: RootState) => state.user.uuid);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const onClose = () => {
        setOpen(false);
        setLoading(false);
    };

    const onClickYes = () => {
        if (investorUUID) {
            setLoading(true);
            Apis.deleteAIFile(investorUUID, uuid)
                .then(({ data }) => {
                    dispatch(LoginActions.updateInvestorInfo(data));
                    dispatch(MessageActions.showMessage({ text: 'Document deleted successfully!', error: false }));
                    onClose();
                })
                .catch((err) => {
                    dispatch(MessageActions.showMessage({ text: String(err), error: true }));
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    };

    return (
        <div>
            <RiDeleteBin6Line
                onClick={() => setOpen(!open)}
                size={'1.3rem'}
                className="cursor-pointer"
                color="#26AE60"
            />
            <HSModal open={open} setOpen={onClose} title="Delete Document">
                <p>Do you want to delete this document?</p>
                <div className="flex justify-center items-center pt-6">
                    <HSButton title="No" light className="mr-4 onboarding_btn_modal_close" onClick={onClose} />
                    <HSButton title="Yes" onClick={onClickYes} className="onboarding_btn_modal" loading={loading} />
                </div>
            </HSModal>
        </div>
    );
};

export default DeleteAIDoc;
